export enum TviConnectDeviceTypeEnum {
  '4G' = '4G',
  'NB IOT' = 'NB IOT',
}
